<template>
    <div class="content-wrapper">
        <div class="container-fluid " style="width: 50%;">
            <div class="row  pt-4">
                <!--左侧开始-->
                <div class="col-lg-12">
                    <div class="card profile-card-2">
                        <div class="card-img-block">
                            <img class="img-fluid" src="../../../assets/images/bg-h.jpg" alt="Card image cap">
                        </div>
                        <div class=" pl-5 pr-5 pt-5">
                            <img src="../../../assets/images/user.png" alt="profile-image" class="profile">
                            <h5 class="card-title">光柔国际广场
                            </h5>
                            <p class="card-text">简介</p>
                        </div>
                        <!------内容部分开始------>
                        <div class="card-body">
                            <ul class="nav nav-tabs nav-tabs-primary top-icon nav-justified">
                                <li class="nav-item">
                                    <a href="javascript:void();" data-target="#profile" data-toggle="pill"
                                       class="nav-link active show"> <span class="">个人资料 <i
                                        class="fa fa-pencil-square-o text float-right" aria-hidden="true"
                                        v-if="!editFlag"
                                        @click="clickEvent"></i>
            <i class="el-icon-circle-check float-right" v-if="editFlag" @click="editFlag=false"></i></span></a>
                                </li>
                                <li class="nav-item">
                                    <a href="javascript:void();" data-target="#messages" data-toggle="pill"
                                       class="nav-link"> <span class="hidden-xs">购买记录</span></a>
                                </li>
                                <li class="nav-item">
                                    <a href="javascript:void();" data-target="#edit" data-toggle="pill"
                                       class="nav-link"> <span class="hidden-xs">账号安全</span></a>
                                </li>
                            </ul>
                            <div class="tab-content p-3">
                                <!---个人资料开始--->
                                <div class="tab-pane active show" id="profile">
                                    <div class="ziliao">
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">用户名称：</span><span v-if="!editFlag">
                    光柔国际广场
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>

                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">用户编码：</span>
                                                <span v-if="!editFlag">
                    15766666666
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">姓：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">昵称：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">中间名：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">名：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">昵称：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">密码：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">性别：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">邮箱：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">手机号：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">微信号：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">QQ号：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">地址：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">出生日期：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">民族：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="media align-items-center">
                                            <div>
                                                <span class="text-dark ">身份证号：</span>
                                                <span v-if="!editFlag">
                   6666666@qq.com
                  </span>
                                                <el-input v-model="input" placeholder="请输入内容" size="mini"
                                                          v-if="editFlag"></el-input>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                                <!---个人资料结束--->
                                <!---购买记录开始--->
                                <div class="tab-pane" id="messages">
                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped">
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span class="float-right font-weight-bold">登录密码<i
                                                        class="zmdi zmdi-border-color"></i></span> Here is
                                                    建议您定期更改密码，设置较复杂的密码可以提高账号的安全性
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span class="float-right font-weight-bold">绑定手机<i
                                                        class="zmdi zmdi-border-color"></i></span> There
                                                    验证后，可用于快速找回登录密码
                                                </td>
                                            </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!---购买吉利结束--->
                                <!---账号管理开始--->
                                <div class="tab-pane" id="edit">
                                    <form>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">发票类型</label>
                                            <div class="col-lg-9">
                                                <button type="button"
                                                        class="btn btn-outline-danger btn-square waves-effect waves-light m-1">
                                                    个人发票
                                                </button>
                                                <button type="button"
                                                        class="btn btn-outline-dark btn-square waves-effect waves-light m-1">
                                                    企业发票
                                                </button>
                                            </div>
                                        </div>
                                           <!---个人发票开始--->
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label"><i
                                                aria-hidden="true" class="fa fa-asterisk text-danger font10 ml-1 "></i>邮箱地址：</label>
                                            <div class="col-lg-9">

                                                <input class="form-control" type="email" value="mark@example.com">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label"><i
                                                aria-hidden="true" class="fa fa-asterisk text-danger font10 ml-1 "></i>个人抬头:</label>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" value="Jhonsan">
                                            </div>
                                        </div>
                                           <!---个人发票结束--->
                                        <!---企业发票开始--->
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label"><i
                                                aria-hidden="true" class="fa fa-asterisk text-danger font10 ml-1 "></i>邮箱地址：</label>
                                            <div class="col-lg-9">

                                                <input class="form-control" type="email" value="mark@example.com">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label"><i
                                                aria-hidden="true" class="fa fa-asterisk text-danger font10 ml-1 "></i>企业名称:</label>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" value="Jhonsan">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label"><i
                                                aria-hidden="true" class="fa fa-asterisk text-danger font10 ml-1 "></i>企业税号：</label>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="file">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">企业地址</label>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="url" value="">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">电话号码</label>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" value="" placeholder="Street">
                                            </div>
                                        </div>


                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">开户银行</label>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="text" value="开户银行">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">银行账号</label>
                                            <div class="col-lg-9">
                                                <input class="form-control" type="password" value="银行账号">
                                            </div>
                                        </div>
                                        <!---企业发票结束--->
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label"></label>
                                            <div class="col-lg-9">
                                                <input type="reset" class="btn btn-success" value="提交">

                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <!---账号管理结束-->
                            </div>
                        </div>
                        <!------内容部分结束------>

                    </div>

                </div>
                <!--左侧开始-->

            </div>

        </div>
        <!-- End container-fluid-->
    </div>


</template>

<script>


export default {
    name: "userInfo",

    data() {
        return {
            input: '',
            editFlag: false,

        }
    },
    created() {

    },
    watch: {},
    methods: {
        clickEvent() {
            this.editFlag = !this.editFlag
        }
    }

}
</script>

<style scoped>
/deep/ .nav-tabs .nav-link {
    color: #7d7b7b;
    font-size: 14px;

}

/deep/ .profile-card-2 .card-img-block {

    padding-left: 0px;

}

/deep/ .profile-card-2 .profile {

    top: 26px;

}
</style>
